import React from "react";
import CookieConsent from "react-cookie-consent";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import './enableCookies.scss'

export const EnableCookies: React.FC<any> = () => {
  return (
    <div className="cookiesEnableWrapper">
      <CookieConsent
        containerClasses="cookiesEnable"
        debug={true}
        overlay
        location="bottom"
        buttonStyle={{display:'none'}}
      >
        <div className="contentClassWrapper">
        <p className="cookiesTitle"><ErrorOutlineIcon className="errorIcon" fontSize="small"/>Enable cookies</p>
        <span className="cookiesDesc">We use cookies to securely sign you in. Please enable cookies on your browser! </span>
        </div>
        
      
      </CookieConsent>
    </div>
  );
};